__webpack_require__.p = "/jenna-portfolio/";